(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Shipment', Shipment);

    Shipment.$inject = ['$resource', 'DateUtils'];

    function Shipment ($resource, DateUtils) {
        var resourceUrl =  'api/shipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.siDate = DateUtils.convertLocalDateFromServer(data.siDate);
                        data.originEtd = DateUtils.convertLocalDateFromServer(data.originEtd);
                        data.destEta = DateUtils.convertLocalDateFromServer(data.destEta);
                        data.freightPaymentDate = DateUtils.convertLocalDateFromServer(data.freightPaymentDate);
                        data.cutoff = DateUtils.convertLocalDateFromServer(data.cutoff);
                        data.blDate = DateUtils.convertLocalDateFromServer(data.blDate);
                        data.lcDate = DateUtils.convertLocalDateFromServer( data.lcDate );
                        data.lcExpiry = DateUtils.convertLocalDateFromServer(data.lcExpiry);
                        data.lcLatestShipment = DateUtils.convertLocalDateFromServer(data.lcLatestShipment);
                        data.boeDate = DateUtils.convertLocalDateFromServer(data.boeDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.siDate = DateUtils.convertLocalDateToServer(data.siDate);
                    data.originEtd = DateUtils.convertLocalDateToServer(data.originEtd);
                    data.destEta = DateUtils.convertLocalDateToServer(data.destEta);
                    data.freightPaymentDate = DateUtils.convertLocalDateToServer(data.freightPaymentDate);
                    data.cutoff = DateUtils.convertLocalDateToServer(data.cutoff);
                    data.blDate = DateUtils.convertLocalDateToServer(data.blDate);
                    data.lcDate = DateUtils.convertLocalDateToServer( data.lcDate );
                    data.lcExpiry = DateUtils.convertLocalDateToServer(data.lcExpiry);
                    data.lcLatestShipment = DateUtils.convertLocalDateToServer(data.lcLatestShipment);
                    data.boeDate = DateUtils.convertLocalDateToServer(data.boeDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.siDate = DateUtils.convertLocalDateToServer(data.siDate);
                    data.originEtd = DateUtils.convertLocalDateToServer(data.originEtd);
                    data.destEta = DateUtils.convertLocalDateToServer(data.destEta);
                    data.freightPaymentDate = DateUtils.convertLocalDateToServer(data.freightPaymentDate);
                    data.cutoff = DateUtils.convertLocalDateToServer(data.cutoff);
                    data.blDate = DateUtils.convertLocalDateToServer(data.blDate);
                    data.lcDate = DateUtils.convertLocalDateToServer( data.lcDate );
                    data.lcExpiry = DateUtils.convertLocalDateToServer(data.lcExpiry);
                    data.lcLatestShipment = DateUtils.convertLocalDateToServer(data.lcLatestShipment);
                    data.boeDate = DateUtils.convertLocalDateToServer(data.boeDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
